module.exports = __webpack_public_path__ + "static/media/pic.f42df37e.jpg";